/* src/app/shared/components/menu/menu.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}
ion-content {
  --background: var(--ion-background-color, #ffffff);
  --padding-top: 0;
  --padding-bottom: 0;
}
.menu-header {
  padding: 24px 16px 16px;
  border-bottom: 1px solid var(--ion-color-step-150, rgba(0, 0, 0, 0.07));
}
.menu-app-name {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: var(--ion-text-color, #000);
  letter-spacing: -0.3px;
}
.menu-list {
  padding-top: 8px;
}
.menu-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid var(--ion-color-step-150, rgba(0, 0, 0, 0.07));
}
.menu-item {
  --padding-start: 16px;
  --padding-end: 16px;
  --min-height: 48px;
  cursor: pointer;
  --background: transparent;
}
.menu-item.menu-item-active {
  --background: rgba(var(--ion-color-primary-rgb, 42, 120, 214), 0.15);
  --color: var(--ion-color-primary, #2a78d6);
  font-weight: 600;
}
.menu-item.menu-item-active .menu-icon {
  color: var(--ion-color-primary, #2a78d6);
}
.menu-item.menu-item-active .menu-label {
  font-weight: 600;
}
.menu-icon {
  font-size: 20px;
  color: var(--ion-color-step-600, #60646b);
  margin-right: 8px;
}
.menu-label {
  font-size: 14px;
  font-weight: 500;
}
/*# sourceMappingURL=menu.component.css.map */
